exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".form-734614f4{margin-top:10px;margin-bottom:10px}.checkbox-e84fb047{margin-right:10px}\n", ""]);

// Exports
exports.locals = {
	"form": "form-734614f4",
	"checkbox": "checkbox-e84fb047"
};